import { render, staticRenderFns } from "./Moment.vue?vue&type=template&id=8f67fd1e&scoped=true&"
import script from "./Moment.vue?vue&type=script&lang=js&"
export * from "./Moment.vue?vue&type=script&lang=js&"
import style0 from "./Moment.vue?vue&type=style&index=0&id=8f67fd1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f67fd1e",
  null
  
)

export default component.exports